export default __webpack_public_path__ + "static/media/homelok.32683772.svg";